import { cronos, hyperEvm, robinhood } from '@reown/appkit/networks';

export const CRONOS_CHAIN_ID = 25;
export const CRONOS_CAIP_NETWORK_ID = 'eip155:25';
/**
 * HyperEVM (999) is a SIGNING network only for the EOA-direct withdrawal path — deposits, auth
 * and everything else still gate on Cronos. Listing it here lets wagmi switch the wallet to 999
 * and send those transactions; it deliberately does NOT change any Cronos-based gating.
 */
export const HYPER_EVM_CHAIN_ID = 999;
/**
 * Robinhood Chain (Arbitrum Orbit, ETH gas) is the SECOND authorization anchor
 * alongside Cronos: a user's Snappy identity may live on either. See
 * `./anchors.ts` for what that means; this module only declares the network.
 */
export const ROBINHOOD_CHAIN_ID = 4663;
export const ROBINHOOD_CAIP_NETWORK_ID = 'eip155:4663';
export const DEFAULT_ROBINHOOD_RPC_URLS = [
    'https://rpc.mainnet.chain.robinhood.com',
] as const;
export const SPEED_TRADING_ADAPTER_ADDRESS =
    '0x210E51ED94c37FF335307B22771870dC5c8D2275' as const;
export const DEFAULT_CRONOS_RPC_URLS = [
    'https://cronos-evm-rpc.publicnode.com',
    'https://mainnet.cronoslabs.org/v1/ea0f1c40f912a166bf1224fedd07b442',
    'https://evm-dev.cronos.org',
    'https://mainnet-archive.cronoslabs.com/v1/89433fdc930781343d3465d593a76dfd',
    'https://mainnet.cronoslabs.com/v1/55e37d8975113ae7a44603ef8ce460aa',
] as const;

export const cronosNetwork = cronos;
export const robinhoodNetwork = robinhood;
export const hyperEvmNetwork = hyperEvm;
export const supportedWalletNetworks = [
    cronosNetwork,
    robinhoodNetwork,
    hyperEvmNetwork,
] as const;

export function normalizeChainId(
    chainId?: number | string,
): number | undefined {
    if (typeof chainId === 'number') {
        return chainId;
    }

    if (typeof chainId !== 'string' || chainId.length === 0) {
        return undefined;
    }

    if (chainId.includes(':')) {
        const [, rawChainId] = chainId.split(':');
        const parsedChainId = Number(rawChainId);
        return Number.isFinite(parsedChainId) ? parsedChainId : undefined;
    }

    const parsedChainId = Number(chainId);
    return Number.isFinite(parsedChainId) ? parsedChainId : undefined;
}

export function isCronosChain(chainId?: number | string): boolean {
    return normalizeChainId(chainId) === CRONOS_CHAIN_ID;
}

export function isRobinhoodChain(chainId?: number | string): boolean {
    return normalizeChainId(chainId) === ROBINHOOD_CHAIN_ID;
}
